// CRA inlines REACT_APP_* at build time. Relative bases (for example /cms/crgci)
// are resolved against the page origin so one image works behind any Ingress host.
// Absolute http(s) URLs from a local .env are left unchanged.
function resolveApiBase(value: string | undefined): string {
  const raw = (value ?? "").trim().replace(/\/$/, "");
  if (!raw) {
    return "";
  }
  if (/^https?:\/\//i.test(raw)) {
    return raw;
  }
  if (
    raw.startsWith("/") &&
    typeof window !== "undefined" &&
    window.location?.origin
  ) {
    return `${window.location.origin}${raw}`;
  }
  return raw;
}

export const urlApi = resolveApiBase(process.env.REACT_APP_API_URL);
export const urlApiHttp = resolveApiBase(process.env.REACT_APP_API_URL_HTTP);
export const urlApiData = resolveApiBase(process.env.REACT_APP_API_URL_DATA);
export const apiKeyData = process.env.REACT_APP_API_KEY_DATA;

export const urlApiDataCRGCI = resolveApiBase(
  process.env.REACT_APP_API_URL_DATA_CRGCI
);
export const apiKeyDataCRGCI = process.env.REACT_APP_API_KEY_DATA_CRGCI;

export const urlApiDataEsg = resolveApiBase(
  process.env.REACT_APP_API_URL_DATA_ESG
);
export const apiKeyDataEsg = process.env.REACT_APP_API_KEY_DATA_ESG;

export const urlApiDataFintech = resolveApiBase(
  process.env.REACT_APP_API_URL_DATA_FINTECH
);
export const apiKeyDataFintech = process.env.REACT_APP_API_KEY_DATA_FINTECH;

export const urlApiDataTehnology = resolveApiBase(
  process.env.REACT_APP_API_URL_DATA_TEHNOLOGIE
);
export const apiKeyDataTehnology =
  process.env.REACT_APP_API_KEY_DATA_TEHNOLOGIE;

export const getFintechTrendsCount =
  process.env.REACT_APP_API_GET_FINTECH_TRENDS_COUNT;

export const urlMockImageCards = `${urlApi}/api/static/image.png`;
